var exports = {
  "yk": "IssueBody__1iGjHw",
  "gk": "IssueBodyModernUx__msBSU8",
  "lg": "IssueBodyTaskList__-FlQre",
  "SO": "IssueBodySubIssueButtonContainer__2He_wh",
};

module.exports = exports;
